"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
exports.default = (function (props) { return (React.createElement("svg", __assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 853.56 1059", className: classNames('sok-svg-icon', props.className) }),
    React.createElement("path", { d: "M834.5 19.07q19 19.07 19.06 45.54v909.68q0 34.94-24.89 59.84T768.84 1059H83.67q-35 0-59.31-24.87T0 974.29V84.72Q0 49.8 24.36 24.89T83.67 0H789q26.44 0 45.5 19.07zm-53 259.45q0-11.62-6.36-28.58t-14.83-26.48L649.17 94.25q-7.41-8.46-21.7-15.34t-26-6.89H83.67c-2.84 0-5.48 1.25-8 3.72a12.24 12.24 0 0 0-3.71 9v889.55a12.32 12.32 0 0 0 3.71 9c2.47 2.45 5.11 3.7 8 3.7h685.17a12.65 12.65 0 0 0 12.71-12.59V278.52z", fill: "#9800a9" }),
    React.createElement("path", { d: "M689 528.52q0 154.26-87.82 236.31t-253.61 82H170.61V222.14h196.14q153 0 237.59 80.76T689 528.52zm-137.6 3.42q0-201.27-177.76-201.27h-70.56v406.81h56.83q191.43 0 191.44-205.54z", fill: "#d600a9" }))); });
//# sourceMappingURL=Dwg.js.map